import { Tooltip, Typography } from '@material-ui/core'
import { InfoOutlined } from '@material-ui/icons'

import Button from '@/components/button'

import { useStyles } from './styles'

interface HeaderProps {
  onCreateNewHerbicideTreatment: () => void
}

export function Header({
  onCreateNewHerbicideTreatment: onOpenSaveHerbicideTreatmentCard,
}: HeaderProps) {
  const classes = useStyles()
  return (
    <header className={classes.container}>
      <div>
        <Typography variant='subtitle1'>Herbicidas</Typography>
        <span className={classes.tooltipContainer}>
          <Tooltip
            title={[
              'Para calcularmos com assertividade os índices de economia e sustentabilidade',
              'utilizamos as informações cadastradas nessa página.',
              'Por favor selecione os herbicidas e dose de concentração do produto',
              'não diluído por hectare.',
            ].join(' ')}
            placement='right'
            arrow
            classes={{
              tooltip: classes.tooltip,
              arrow: classes.arrow,
            }}
          >
            <InfoOutlined />
          </Tooltip>
          <Typography variant='subtitle2' color='inherit'>
            Cadastre aqui seus tratamentos com defensivos.
          </Typography>
        </span>
      </div>

      <Button
        className={classes.button}
        outlined
        onClick={onOpenSaveHerbicideTreatmentCard}
      >
        Criar novo tratamento
        <span className='material-symbols-outlined'>gas_meter</span>
      </Button>
    </header>
  )
}
